import { type ClientInferRequest } from "@ts-rest/core";

import { client } from "../client";
import { type apiContract } from "../contract";

type GetSupplierRequest = ClientInferRequest<
  typeof apiContract.v1.pos.suppliers.get
>;

export type GetSupplierArgs = GetSupplierRequest["query"];

export async function getSupplier({ partnerId, schoolId }: GetSupplierArgs) {
  const response = await client.v1.pos.suppliers.get({
    query: {
      partnerId,
      schoolId
    }
  });

  if (response.status === 200) {
    return response.body;
  }

  throw response;
}
